import React from "react";
import { FreeplayUser } from "@freeplay/shared-code";
import { useReducer } from "react";
import { useScrollToTop } from "../components/hooks/scrollToTopHook";
import { BespokeGameView } from "../views/BespokeGameView";
import { useEvent } from "../contexts/EventContext";
import { MixPanelEventEnum, useMixpanel } from "../utils/analytics";

export function waitPlease(seconds: number): Promise<void> {
    return new Promise((res, rej) => {
        setTimeout(() => {
            res();
        }, seconds * 1000);
    });
}

export const BespokeGameController = (): JSX.Element => {
    const { currentEvent, sendPicks } = useEvent();
    const [state, dispatch] = useReducer(picksReducer, {
        choice: 1,
        choices: [],
    });

    useScrollToTop();
    useMixpanel(MixPanelEventEnum.MAKE_PICK_SCREEN_VIEWED, currentEvent?.id ?? -1);

    if (!currentEvent) {
        return <></>;
    }

    const handleSendPicks = () => {
        sendPicks({
            bespokeSelections: [...state.choices],
        });
    };

    return <BespokeGameView state={state} dispatch={dispatch} sendPicks={handleSendPicks} />;
};

export type BespokeGameState = {
    choice: number;
    choices: number[];
    fpUser?: FreeplayUser;
};

export type BespokeGameActions =
    | { type: "setSelection"; choice: number; index: number }
    | { type: "setChoices"; choices: number[] }
    | { type: "clearPicks" };

const picksReducer = (state: BespokeGameState, action: BespokeGameActions): BespokeGameState => {
    switch (action.type) {
        case "setSelection": {
            const choices = [...state.choices];
            choices[action.index] = action.choice;
            return {
                ...state,
                choices,
            };
        }
        case "setChoices": {
            return { ...state, choices: action.choices };
        }
        case "clearPicks":
            return {
                ...state,
                choices: [],
            };
    }
};
